import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const ItemFeaturesSection = ({ onUpdate, boostInput = false }) => {
  const [currentItemFeature, setCurrentItemFeature] = useState('');
  const [currentOperator, setCurrentOperator] = useState('');
  const [currentThreshold, setCurrentThreshold] = useState('');
  const [boost, setBoost] = useState(1);

  const operatorOptions = [
    { id: '<=', label: '<=' },
    { id: '>=', label: '>=' }
  ];

  const itemFeatureOptions = [
    { id: 'text_length', label: 'Text Length' }
  ];

  const handleItemFeatureChange = (event) => {
    setCurrentItemFeature(event.target.value);
    
    // Set default operator and threshold for text_length
    setCurrentOperator('>=');
    setCurrentThreshold('1');
  };

  const handleItemFeaturesAction = (actionType) => {
    if (!currentItemFeature || !currentOperator || !currentThreshold) return;
    
    const thresholdValue = parseInt(currentThreshold);
    if (isNaN(thresholdValue)) return;
    
    const updateData = {
      action: actionType,
      filter: 'numeric',
      field: currentItemFeature,
      value: thresholdValue,
      operator: currentOperator,
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    
    // Reset after adding
    setCurrentItemFeature('');
    setCurrentOperator('');
    setCurrentThreshold('');
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl sx={{ flex: 1 }}>
          <InputLabel>Feature</InputLabel>
          <Select
            value={currentItemFeature}
            label="Feature"
            onChange={handleItemFeatureChange}
          >
            {itemFeatureOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 100 }}>
          <InputLabel>Operator</InputLabel>
          <Select
            value={currentOperator}
            label="Operator"
            onChange={(e) => setCurrentOperator(e.target.value)}
          >
            {operatorOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Threshold"
          type="number"
          value={currentThreshold}
          onChange={(e) => setCurrentThreshold(e.target.value)}
          sx={{ flex: 1 }}
          placeholder="Enter threshold"
        />
      </Box>
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleItemFeaturesAction('include')}
          disabled={!currentItemFeature || !currentOperator || !currentThreshold}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleItemFeaturesAction('boost')}
            disabled={!currentItemFeature || !currentOperator || !currentThreshold}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleItemFeaturesAction('exclude')}
          disabled={!currentItemFeature || !currentOperator || !currentThreshold}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default ItemFeaturesSection;

